export const ATTESTATION_BLOCKED_REASONS = {
  missingMileage: "MISSING_MILEAGE",
} as const;

export type AttestationBlockedReason =
  (typeof ATTESTATION_BLOCKED_REASONS)[keyof typeof ATTESTATION_BLOCKED_REASONS];

export interface AttestationDay {
  /** YYYY-MM-DD in the clinic's timezone */
  date: string;
  isAttested: boolean;
  isBlocked: boolean;
  blockedReason: AttestationBlockedReason | null;
}

export interface AttestationPayPeriod {
  /** YYYY-MM-DD, inclusive */
  startDate: string;
  /** YYYY-MM-DD, inclusive */
  endDate: string;
}

/**
 * An inclusive YYYY-MM-DD window to ask for day status over — the days the calendar is
 * showing, which is not the same thing as the pay period.
 */
export interface AttestationDateRange {
  /** YYYY-MM-DD, inclusive */
  startDate: string;
  /** YYYY-MM-DD, inclusive */
  endDate: string;
}

/** Response shape of the getAttestationStatus endpoint. */
export interface AttestationStatus {
  /**
   * The pay period the provider is currently being asked to close out. Always the live period,
   * whatever window was requested — it is what the banner and the catch-up run speak for.
   */
  payPeriod: AttestationPayPeriod;
  /**
   * Every day with an attestation state in the requested range *and* in `payPeriod`, so both
   * surfaces can be served from one call: the day strip marks whatever week is on screen, while
   * the banner still knows the whole period even when the screen is showing only part of it.
   *
   * This therefore reaches outside `payPeriod` — scope with `daysInCurrentPayPeriod` before
   * counting anything, and read it whole only for the day-strip markers.
   */
  days: AttestationDay[];
  unattestedCount: number;
  blockedCount: number;
}
